module.exports = [{
      plugin: require('/builds/Dunckelfeld/warsteiner/warsteiner-site/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/builds/Dunckelfeld/warsteiner/warsteiner-site/src/components/common/Layout/Layout.js"},
    },{
      plugin: require('/builds/Dunckelfeld/warsteiner/warsteiner-site/node_modules/gatsby-plugin-graphql-preview/gatsby-browser.js'),
      options: {"plugins":[],"fieldName":"craft","typeName":"Craft","url":"https://cms.warsteiner.de/api","headers":{"Authorization":"bearer XXjBDOrVUHG6iIUgWDoQL1uxX0L5fbe3Avd2AnpONbMUFDnQFZfwoTe5e-2PesWe"},"refetchInterval":120},
    },{
      plugin: require('/builds/Dunckelfeld/warsteiner/warsteiner-site/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[],"autoLabel":true},
    },{
      plugin: require('/builds/Dunckelfeld/warsteiner/warsteiner-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
